package com.vidaensupalabra.vsp.datos

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.coroutines.CancellationException
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue

data class ArdeEntity(
    val year: Int,
    val month: Int,
    val day: Int,
    val reference: String,
    var devocional: String
)

object ArdeRepository {
    private val _ardeData = mutableStateListOf<ArdeEntity>()
    var isDataLoaded by mutableStateOf(false)
        private set
    private val client = HttpClient(Js)
    private const val FIREBASE_USERS_URL = "https://vidaensupalabra-830e4-default-rtdb.firebaseio.com/usuarios"

    suspend fun loadDataIfNeeded() {
        if (!isDataLoaded) {
            try {
                val csvData: String = client.get("files/Datos_Arde.csv").bodyAsText()
                val parsed = csvData.lines().drop(1).mapNotNull { line ->
                    val parts = line.split(',')
                    if (parts.size >= 4) {
                        ArdeEntity(
                            year = parts[0].toInt(),
                            month = parts[1].toInt(),
                            day = parts[2].toInt(),
                            reference = parts[3],
                            devocional = ""
                        )
                    } else null
                }
                _ardeData.clear()
                _ardeData.addAll(parsed)
            } catch (e: CancellationException) {
                throw e
            } catch (e: Exception) {
                println("Error loading ARDE data: ${e.message}")
            } finally {
                isDataLoaded = true
            }
        }
    }

    fun getArde(year: Int, month: Int, day: Int): ArdeEntity? =
        _ardeData.find { it.year == year && it.month == month && it.day == day }

    suspend fun getDevocional(uid: String, reference: String): String? {
        val safeRef = reference.replace(".", "_").replace("#", "").replace("$", "").replace("[", "").replace("]", "")
        return try {
            val response = client.get("$FIREBASE_USERS_URL/$uid/devocionales/$safeRef.json").bodyAsText()
            if (response == "null" || response.isBlank()) null else {
                Json { ignoreUnknownKeys = true }.decodeFromString<String>(response)
            }
        } catch (e: CancellationException) {
            throw e
        } catch (e: Exception) {
            e.printStackTrace()
            null
        }
    }

    suspend fun saveDevocional(uid: String, reference: String, text: String): Boolean {
        val safeRef = reference.replace(".", "_").replace("#", "").replace("$", "").replace("[", "").replace("]", "")
        return try {
            val response = client.put("$FIREBASE_USERS_URL/$uid/devocionales/$safeRef.json") {
                contentType(ContentType.Application.Json)
                setBody(Json.encodeToString(text))
            }
            response.status.value in 200..299
        } catch (e: CancellationException) {
            throw e
        } catch (e: Exception) {
            e.printStackTrace()
            false
        }
    }
}